// extracted by mini-css-extract-plugin
module.exports =  {"main-container":"parameters__main-container___NraG8","mainContainer":"parameters__main-container___NraG8"};